module.exports = __webpack_public_path__ + "public/img/03.fde922f5.png";